import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "components/Common/SvgIcon";
import Button from "components/Common/Button";
import "./style.scss";

class Splash extends React.Component {
  getIcon() {
    const {
      icon,
      fillColor,
      strokeDashArray,
      stroke
    } = this.props;

    if (icon) {
      return (
        <SvgIcon
          icon={icon}
          customClassName="Splash__icon"
          fillColor={fillColor}
          strokeDashArray={strokeDashArray}
          stroke={stroke}
        />
      );
    }

    return null;
  }

  getButton() {
    const { buttonIcon, buttonLabel, buttonAction } = this.props;

    if (buttonAction) {
      return (
        <Button
          icon={buttonIcon}
          text={buttonLabel || "Go"}
          onClick={buttonAction}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className="Splash g-view">
        <div className="g-view__empty">
          {this.getIcon()}
          <h1>{this.props.title}</h1>
          <p>{this.props.description}</p>
          {this.getButton()}
        </div>
      </div>
    );
  }
}

Splash.defaultProps = {
  fillColor: "currentColor",
  stroke: "",
  strokeDashArray: "",
  buttonIcon: "Upward"
};

Splash.propTypes = {
  fillColor: PropTypes.string,
  stroke: PropTypes.string,
  strokeDashArray: PropTypes.string,
  buttonIcon: PropTypes.string
};

export default Splash;
